import { Link } from "react-router-dom";
import { FileCheck, Mail, MapPin } from "lucide-react";
import styles from "./LegalPage.module.css";

const TermsConditions = () => {
  return (
    <div className={styles.legalContainer}>
      <header className={styles.legalHeader}>
        <div className={styles.headerContent}>
          <div className={styles.brandRow}>
            <div className={styles.logoBadge}>
              <FileCheck size={24} className={styles.logoIcon} />
            </div>
            <div>
              <h1 className={styles.title}>Terms &amp; Conditions</h1>
              <p className={styles.subtitle}>My AsmitA — Smart Home IoT & Society Operations Platform</p>
            </div>
          </div>
          <div className={styles.headerMeta}>
            <span className={styles.metaBadge}>Last Updated: October 2026</span>
            <span className={styles.metaBadge}>Version 1.0 (Production)</span>
          </div>
        </div>
      </header>

      <main className={styles.legalBody}>
        <div className={styles.introCard}>
          <p>
            Please read these Terms and Conditions (&quot;Terms&quot;) carefully before utilizing the 
            <strong> My AsmitA</strong> mobile application or admin portal. By registering an account, 
            generating visitor passes, or engaging with society amenities, you agree to be legally bound by these Terms.
          </p>
        </div>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>
            <span className={styles.sectionNumber}>1</span> Eligibility &amp; Account Responsibility
          </h2>
          <div className={styles.contentBlock}>
            <p>
              Access to society management and gate clearance features is restricted to verified owners, registered tenants, authorized family members, 
              facility staff, and certified security personnel approved by the respective society management committee. 
              Users are strictly responsible for maintaining the confidentiality of their login credentials, OTP codes, and digital gate pass tokens.
            </p>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>
            <span className={styles.sectionNumber}>2</span> Visitor &amp; Gate Pass Usage Rules
          </h2>
          <div className={styles.contentBlock}>
            <ul className={styles.bulletList}>
              <li><strong>Lawful Purposes Only:</strong> Pre-approved guest, delivery, and cab passes must be generated only for legitimate, verified visitors.</li>
              <li><strong>Gate Security Discretion:</strong> The issuance of a digital gate pass does not bypass physical security verification. Security personnel reserve the right to verify vehicle contents, inspect credentials, or deny entry if required for safety or bylaws compliance.</li>
              <li><strong>Fraudulent Usage:</strong> Creating fictitious visitor entries or misrepresenting visitor identity is strictly prohibited and subject to immediate revocation of app privileges.</li>
            </ul>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>
            <span className={styles.sectionNumber}>3</span> Amenity Bookings &amp; Society Operations
          </h2>
          <div className={styles.contentBlock}>
            <p>
              Amenity reservations (clubhouse, pool, sports courts, banquet facilities) are subject to your individual society&apos;s specific rules, 
              cancellation windows, and operating hours. The platform functions as an automated facilitator; management committees retain ultimate governance over facility rules.
            </p>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>
            <span className={styles.sectionNumber}>4</span> Community Conduct &amp; Content Guidelines
          </h2>
          <div className={styles.contentBlock}>
            <p>
              When utilizing community message boards, notice boards, and helpdesk chat, users must maintain civil and respectful communication. 
              Posting defamatory, unlawful, harassing, commercial advertising, or unauthorized multimedia content is strictly prohibited.
            </p>
          </div>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>
            <span className={styles.sectionNumber}>5</span> Termination of Access
          </h2>
          <div className={styles.contentBlock}>
            <p>
              Upon termination of tenancy, sale of property, or revocation of security guard clearance by society administrators, access privileges to unit-specific workflows are immediately de-provisioned.
            </p>
          </div>
        </section>

        <section className={styles.contactSection}>
          <h2>Support &amp; Grievances</h2>
          <p>For inquiries regarding these Terms and Conditions or society operational rules, please reach out:</p>
          <div className={styles.contactGrid}>
            <div className={styles.contactItem}>
              <Mail size={18} />
              <div>
                <strong>Email:</strong>
                <a href="mailto:support@myasmita.com">support@myasmita.com</a>
              </div>
            </div>
            <div className={styles.contactItem}>
              <MapPin size={18} />
              <div>
                <strong>Location:</strong>
                <span>Mumbai, Maharashtra, India</span>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className={styles.legalFooter}>
        <div className={styles.footerContent}>
          <p>&copy; {new Date().getFullYear()} AsmitA Smart Home IoT &amp; Society Operations. All rights reserved.</p>
          <div className={styles.footerLinks}>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/login">Sign In</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TermsConditions;
